import * as classNames from 'classnames';
import { ExcelTool } from '../excel/excel_tool';
import { i18n } from '../../i18n/i18n';
import * as React from 'react';
import style from './WDataColumns.less';
import { WActionButton } from '../elements/WActionButton';

interface WDataColumnsProps extends React.ClassAttributes<any> {
    entity: string;
    module: string;
    columns: Array<any>;
    data: Array<any>;
    showView?: boolean;
    showEdit?: boolean;
    showDelete?: boolean;
    showCopy?: boolean;
    customActions?: ReadonlyArray<any>;
    externalHeaderElements?: Array<JSX.Element>;
    customClass?: string;
    onAction(action: string, row: any): void;
}

interface WDataColumnsState {
}

export class WDataColumns extends React.Component<WDataColumnsProps, WDataColumnsState>  {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.onExport = this.onExport.bind(this);
    }

    renderActionColumns(dataRow: any, idx: number) {
        const btns: Array<JSX.Element> = [];
        if (this.props.showView) {
            btns.push(
                <div>
                    <WActionButton
                        label='Ansehen'
                        action='view'
                        key={'but_view'}
                        onAction={(action: string) => this.props.onAction(action, dataRow)}
                        tooltip={'Eine Ansicht des Datensatzes wird geöffnet.'}
                    />
                </div>
            );
        }
        if (this.props.showEdit) {
            btns.push(
                <div>
                    <WActionButton
                        label='Bearbeiten'
                        action='edit'
                        key={'but_edit'}
                        onAction={(action: string) => this.props.onAction(action, dataRow)}
                        tooltip={i18n('Ein Dialog zum Bearbeiten des Datensatzes wird geöffnet.', 'sys')}
                    />
                </div>
            );
        }
        if (this.props.showDelete) {
            btns.push(
                <div>
                    <WActionButton
                        label='Löschen'
                        action='delete'
                        key={'but_delete'}
                        onAction={(action: string) => this.props.onAction(action, dataRow)}
                        tooltip={i18n('Der Datensatz wird entfernt.', 'sys')}
                    />
                </div>
            );
        }
        if (this.props.showCopy) {
            btns.push(
                <div>
                    <WActionButton
                        label='Kopieren'
                        action='copy'
                        key={'but_copy'}
                        onAction={(action: string) => this.props.onAction(action, dataRow)}
                        tooltip={i18n('Der Datensatz wird kopieren.', 'sys')}
                    />
                </div>
            );
        }
        if (this.props.customActions) {
            this.props.customActions.map((action: any) => {
                let buttonKey = action.key ? action.key : '';
                if (dataRow.buttonMode) {
                    buttonKey = dataRow.buttonMode;
                }
                let actionStyle = undefined;
                if (action.styleFunc) {
                    actionStyle = action.styleFunc(dataRow);
                }
                btns.push(
                    <div>
                        <WActionButton
                            label={action.label}
                            action={buttonKey}
                            key={'but_' + buttonKey}
                            onAction={() => action.func(dataRow, idx)}
                            tooltip={action.info}
                            styleProps={actionStyle}
                        />
                    </div>
                );
            });
        }
        return btns;
    }

    render() {
        // console.log(this.props);
        const columns = this.props.columns;
        const data = this.props.data;
        const rows: Array<JSX.Element> = [];
        if (Array.isArray(columns) && Array.isArray(data)) {
            rows.push(
                <div key={-1} className={style.row}>
                    <div className={style.cell}></div>
                    {data.map((d: any, idx2: number) => {
                        return <div key={idx2} className={style.cell}>
                            <div className={style.rowContainer}>
                                {this.renderActionColumns(d, idx2)}
                            </div>
                        </div>;
                    })}
                </div>
            );
            columns.map((attr: any, idx: number) => {
                if (attr.show === false || attr.show_orig === false) {
                    return;
                }
                rows.push(
                    <div key={idx} className={style.row}>
                        <div className={classNames(style.cell, style.stickyLeft)}>{attr.HeaderText || attr.Header}</div>
                        {data.map((d: any, idx2: number) => {
                            const row: any = {
                                value: d[attr.accessor],
                                original: d
                            };
                            return <div key={idx2} className={style.cell}>
                                {typeof attr.Cell === 'function' ? attr.Cell(row) : row.value}
                            </div>;
                        })}
                    </div>
                );
            });
        }

        return (
            <div className={this.props.customClass ? style[this.props.customClass] : null}>
                <div className={style.rowContainer}>
                    <WActionButton
                        label={'Export Table to Excel'}
                        action='export'
                        key={'action_export'}
                        place='bottom'
                        onAction={this.onExport}
                        tooltip={i18n('Die Exportdatei wird erstellt '
                            + 'und sofort heruntergeladen. Ihr Browser erkennt diesen Prozess und behandelt die heruntergeladene Datei '
                            + 'wie üblich/konfiguriert.', 'sys')}
                    />
                    {this.props.externalHeaderElements ? this.props.externalHeaderElements : ''}
                </div>
                <div className={style.DataColumnsTable}>
                    {rows}
                </div>
                {data.length === 0 ? <span style={{ fontStyle: 'italic', fontSize: 12 }}>Kein Datensatz vorhanden.</span> : null}
            </div>
        );
    }

    onExport() {
        const et = new ExcelTool();
        et.dataToWb(this.props.entity, this.props.columns, this.props.data);
    }
}
